export default __webpack_public_path__ + "static/media/5.534f6c87.svg";